import { withStyles, Switch } from '@material-ui/core';
import { colors } from 'design-system';

const CustomSwitch = withStyles({
  switchBase: {
    color: colors.silver,
    '&$checked': {
      color: colors.bright_turquoise,
    },
    $track: {
      backgroundColor: colors.gallery,
    },
    '&$checked + $track': {
      backgroundColor: colors.onahau,
      opacity: 1,
    },
  },
  checked: {},
  track: {
    backgroundColor: colors.gallery,
    opacity: 1,
  },
})(Switch);

export default CustomSwitch;
